import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ArrowDown } from '../../assets/images/arrow-down.svg';
import { ReactComponent as CircleStarIcon } from '../../assets/images/circle-star.svg';
import { ReactComponent as CloseIcon } from '../../assets/images/close-icon.svg';
import { ReactComponent as FlagIcon } from '../../assets/images/flag.svg';
import { ReactComponent as UserPlusIcon } from '../../assets/images/user-plus.svg';
import ButtonWithIcon from '../shared/ButtonWithIcon/ButtonWithIcon';
import Modal from '../shared/Modal/Modal';

import styles from './ReferralProcess.module.scss';

export const ReferralProcessModal = ({ show, onClose }) => {
  const { t } = useTranslation('common');

  const steps = [
    {
      id: 'refer',
      icon: <UserPlusIcon />,
      text: t('referralProcess.step1'),
    },
    {
      id: 'hired',
      icon: <FlagIcon />,
      text: t('referralProcess.step2'),
    },
    {
      id: 'reward',
      icon: <CircleStarIcon />,
      text: t('referralProcess.step3'),
    },
  ];

  return (
    <Modal show={show} onHide={onClose} centered dialogClassName={styles.referralModal}>
      <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
        <CloseIcon />
      </button>
      <Modal.Body className={styles.modalBody}>
        <p className={styles.modalTitle}>{t('referralProcess.title')}</p>
        <div className={styles.modalStepList}>
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <div className={styles.modalStepBox}>
                <div className={styles.icon}>{step.icon}</div>
                <p className={styles.modalStepText}>{step.text}</p>
              </div>
              {index !== steps.length - 1 && (
                <div className={styles.modalArrow}>
                  <ArrowDown />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        <ButtonWithIcon
          variant="tertiary-36"
          onClick={onClose}
          text={t('buttons.okay')}
          textClassName={styles.okayText}
        />
      </Modal.Footer>
    </Modal>
  );
};
